import basic from "../assets/real_estate_plan.jpg";
import { getImage, getText } from './customization';

export const OPERATION_TYPES = [
  { key: 'sale', value: 'Venta' },
  { key: 'rent', value: 'Renta' },
  { key: 'developments', value: 'Desarrollos' }
];

export const FACILITY_TYPES = [
  { key: 'apartment', value: 'Departamento' },
  { key: 'house', value: 'Casa' },
  { key: 'condominium', value: 'Condominio' },
  { key: 'commercial_space', value: 'Espacio Comercial' },
  { key: 'commercial_lot', value: 'Terreno' }
];

export const COMMUNITIES = [
  {
    href:'/community/cabo-del-sol',
    img: 'https://www.windermereloscabos.com/thumbs/416x284/uploads/Cabo%20Del%20Sol.jpeg',
    label: 'Cabo del Sol'
  },
  {
    href:'/community/diamante',
    img: 'https://www.windermereloscabos.com/thumbs/416x284/uploads/unnamed-2.91.jpg',
    label: 'Diamante'
  },
  {
    href:'/community/cabo-bello',
    img: 'https://www.windermereloscabos.com/thumbs/416x284/uploads/Cabo%20Bello%20Header%20v2.30.jpg',
    label: 'Cabo Bello'
  },
  {
    href:'/community/querencia',
    img: 'https://www.windermereloscabos.com/thumbs/416x284/uploads/Querencia.jpeg',
    label: 'Querencia'
  },
  {
    href:'/community/quivira-hub',
    img: 'https://www.windermereloscabos.com/thumbs/416x284/uploads/Quivira%20View.jpg',
    label: 'Quivira Hub'
  },
  {
    href:'/community/palmilla',
    img: 'https://www.windermereloscabos.com/thumbs/416x284/uploads/Palmilla.jpeg',
    label: 'Palmilla'
  }
];

export const CONTACTS = [
  { label: "Nuestra Oficina", href: "/our-office" },
  { label: "Contacto", href: "/contacto" },
  { label: "Agentes", href: "/our-agents" },
];

export const ICONS = [
  {
    name: "logo-facebook",
    link: getText('SocialLinks.Facebook'),
    src: getImage('FacebookIcon'),
    hover: getImage('FacebookIconHover'),
  },
  {
    name: "logo-instagram",
    link: getText('SocialLinks.Instagram'),
    src: getImage('InstagramIcon'),
    hover: getImage('InstagramIconHover'),
  },
  {
    name: "logo-tiktok",
    link: getText('SocialLinks.TikTok'),
    src: getImage('TikTokIcon'),
    hover: getImage('TikTokIconHover'),
  },
  {
    name: "logo-twitter",
    link: getText('SocialLinks.Twitter'),
    src: getImage('TwitterIcon'),
    hover: getImage('TwitterIconHover'),
  },
];

export const LISTINGS = [
  { label: "Listings", href: "/listings" },
  { label: "Developer Zone", href: "/developer-zone" },
  { label: "L.C. Listings Opportunities", href: "/listings-opportunities" },
];

export const CITIES = [
  { label: "Los Cabos", href: "/" },
  { label: "Baja California", href: "/baja-california" },
  { label: "Acapulco", href: "/acapulco" },
];

export const FEATURES_AND_AMENITIES = [
  { label: "Alberca", firebaseKey: "swimmingPool" },
  { label: "Jardin", firebaseKey: "garden" },
  { label: "Áreas Verdes", firebaseKey: "greenAreas" },
  { label: "Vigilancia", firebaseKey: "surveillance" },
  { label: "Acceso a Internet", firebaseKey: "internetAccess" },
  { label: "Salón Usos Multiples", firebaseKey: "multipurposeRoom" },
  { label: "Terrazas", firebaseKey: "terraces" },
  { label: "Cuarto de Servicio", firebaseKey: "serviceRoom" },
  { label: "Gym", firebaseKey: "gym" },
  { label: "Lobby", firebaseKey: "lobby" },
];